import Link from 'next/link'

import { LogoMark } from '@/components/site/brand-icons'
import { cms } from '@/lib/cms'
import { cn } from '@/lib/utils'

interface LogoProps {
    profileId?: string
    shortName?: string | null
    tone?: 'light' | 'dark'
    className?: string
}

export const Logo = ({ profileId, shortName, tone = 'light', className }: LogoProps) => {
    const dark = tone === 'dark'

    return (
        <Link href='/' className={cn('group flex items-center gap-3 rounded-full outline-none focus-visible:ring-3 focus-visible:ring-ring/50', className)}>
            <LogoMark className='size-10 shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]' />
            <span className='flex flex-col leading-none'>
                {shortName ? (
                    <span
                        data-mdlfy-cms={cms('salon_profile', profileId, 'short_name')}
                        className={cn('font-heading text-[1.6rem] font-semibold tracking-[0.2em] uppercase', dark ? 'text-cream-50' : 'text-navy-900')}
                    >
                        {shortName}
                    </span>
                ) : (
                    <span className={cn('font-heading text-[1.6rem] font-semibold tracking-[0.2em] uppercase', dark ? 'text-cream-50' : 'text-navy-900')}>
                        Aurum
                    </span>
                )}
                <span className={cn('mt-1 text-[0.625rem] font-semibold tracking-[0.32em] uppercase', dark ? 'text-gold-300' : 'text-gold-700')}>
                    Salon and Beauty
                </span>
            </span>
        </Link>
    )
}
